/**
 * Ad unit slot IDs mapped to page placements.
 * Create ad units in the AdSense dashboard and set the corresponding
 * environment variables to enable per-placement tracking.
 */
export const AD_SLOTS = {
  landing: import.meta.env.VITE_AD_SLOT_LANDING || '',
  about: import.meta.env.VITE_AD_SLOT_ABOUT || '',
  howItWorks: import.meta.env.VITE_AD_SLOT_HOW_IT_WORKS || '',
  faq: import.meta.env.VITE_AD_SLOT_FAQ || '',
  contact: import.meta.env.VITE_AD_SLOT_CONTACT || '',
  privacyPolicy: import.meta.env.VITE_AD_SLOT_PRIVACY_POLICY || '',
  termsOfService: import.meta.env.VITE_AD_SLOT_TERMS_OF_SERVICE || '',
  leagues: import.meta.env.VITE_AD_SLOT_LEAGUES || '',
  leagueDetails: import.meta.env.VITE_AD_SLOT_LEAGUE_DETAILS || '',
  tournaments: import.meta.env.VITE_AD_SLOT_TOURNAMENTS || '',
  tournamentDetails: import.meta.env.VITE_AD_SLOT_TOURNAMENT_DETAILS || '',
  blog: import.meta.env.VITE_AD_SLOT_BLOG || '',
} as const;
